import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { CssBaseline } from "@mui/material";
import AppRoutes from "./routes/AppRoutes";
import { ThemeProvider } from "./context/ThemeContext";
import { SnackbarProvider } from "./components/common/CustomSnackbar";
import { fetchLoggedInUser } from "./redux/slices/userSlice";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchLoggedInUser());
  }, [dispatch]);

  return (
    <ThemeProvider>
      <CssBaseline />
      <SnackbarProvider
        defaultPosition={{ vertical: "top", horizontal: "right" }}
      >
        <AppRoutes />
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
